input,
button,
select,
textarea {
  outline: none;
}

.home_span_warn {
  position: absolute;
  bottom: -40px;
  left: 150px;
}

.body {
  padding: 5px;
  width: 100%;
  background: url(../images/xizang/background.png);
}

.body_icon {
  width: 1440px;
  margin: 20px auto;
}

.outForm_pay {
  position: relative;
  width: 1440px;
  /* height: 470px; */
  margin: 0 auto;
}

.outForm_pay_qingdao {
  position: relative;
  width: 100%;
  /* height: 600px; */
  /* background: url(../images/qingdao3.png) no-repeat center; */
  margin: 0 auto;
  background-size: cover;
}

.onForm {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  width: 400px;
  right: 10%;
  top: 10%;
}

.onForm_pay {
  margin-bottom: 45px;
  padding-bottom: 20px;
  margin-left: 4px;
  width: 100%;
  background: #ffffff;
  -webkit-box-shadow: 0 0px 9px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0px 9px rgba(0, 0, 0, 0.1);
}

.top_pay {
  margin-top: 20px;
  padding-top: 10px;
  width: 92%;
  height: 52px;
  border-bottom: 1px solid #e22721;
  margin-left: auto;
  margin-right: auto;
}

.topSpan_pay {
  font-size: 22px;
  color: #e22721;
  font-weight: bold;
}

.middle_pay {
  position: relative;
  width: 92%;
  margin: 0 auto;
}

.icon_dayin {
  width: 50px;
  position: absolute;
  right: 0;
}

.middle_pay_left {
  display: inline-block;
  vertical-align: top;
  width: 55%;
  height: 390px;
}

.middle_pay_left_org {
  margin-top: 6%;
  width: 670px;
  /* height: 405px; */
  background: rgba(255, 255, 255, 1);
  /* box-shadow: 0px 4px 18px 0px rgb(0 0 0 / 8%); */
  /* border-radius: 4px; */
}

.middle_pay_right_org {
  margin-top: 14%;
  margin-left: 7%;
  width: 86%;
  height: 74%;
  color: #eb8500;
  font-size: 15px;
  background-color: #fff2de;
}

.middle_pay_right {
  display: inline-block;
  vertical-align: top;
  width: 38%;
  height: 390px;
}

.middle_box {
  padding-top: 30px;
  width: 84%;
  margin: 0 auto;
}

.box {
  padding: 5px;
  width: 145px;
  height: 145px;
}

.box_on {
  margin: 0 auto;
  width: 128px;
  height: 128px;
  background-color: rgb(255, 255, 255);
  border-radius: 16px;
  box-shadow: 0px 0px 10px 10px rgba(230, 242, 248, 0.5);
  text-align: center;
  cursor: pointer;
}

.box_on:hover {
  width: 138px;
  height: 138px;
}

.img-size {
  width: 96px;
  height: 96px;
}

.img-span {
  font-size: 12px;
  display: block;
  text-align: center;
  font-family: PingFangSCRegular;
  color: #464a4c;
}

.img_pay {
  margin-top: 20px;
  margin-bottom: 20px;
}

.span_pay_top {
  font-size: 20px;
  color: #ff9000;
  font-weight: bold;
  padding-left: 23px;
  padding-top: 16px;
}

.span_pay {
  font-size: 18px;
  padding: 20px;
}

.button_submit {
  width: 153px;
  height: 40px;
}

.button_clear {
  margin-left: 58px;
  width: 153px;
  height: 40px;
}

.verificationCode {
  width: 100px;
  height: 37px;
  margin-left: 15px;
  margin-top: 2px;
}

p {
  margin-bottom: 4px !important;
}

.middle_payInfo {
  position: relative;
  width: 900px;
  padding-top: 20px;
  margin: 10px auto;
}

.bottom_payInfo {
  /* border: 1px solid #ccc; */
  width: 900px;
  padding-top: 20px;
  margin: 10px auto;
  text-align: center;
}

.title_t {
  text-align: center;
  font-size: 18px;
}

.title-ti span {
  font-size: 12px;
  margin-left: 44px;
  color: black;
  text-decoration: none;
}

.form_f {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
  width: 820px;
  height: 250px;
  margin: 14px auto;
}

.url_button {
  background-color: #3c76a6;
  color: white;
  width: 140px;
  height: 35px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  margin-top: 20px;
  border: 0px;
}

.url_button_clear {
  margin-left: 20px;
  background-color: #3c76a6;
  color: white;
  width: 140px;
  height: 35px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  margin-top: 20px;
  border: 0px;
}

.row {
  height: 300px;
  text-align: center;
  background-color: white;
}

.row_p {
  font-size: 18px;
  text-align: center;
  color: green;
  margin-top: 30px;
}

/* .heada {
  background: url(../images/tou.png) no-repeat;
  padding: 0;
  width: 100%;
  height: 196px;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
} */

.home {
  width: 100%;
  display: flex;
}

.home_left {
  padding: 30px;
  flex: 1;
}

.home_right {
  padding: 88px 0 0 20px;
  flex: 1;
}

.home_right_nei {
  position: relative;
  width: 500px;
  height: 328px;
  border: 1px solid #ddd;
  z-index: 400;
}

.home_right_topLeft {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  position: absolute;
  background: white;
  width: 130px;
  height: 50px;
  left: -1px;
  top: -51px;
  border: 1px solid #ddd;
  border-bottom: 0px solid #ddd;
  z-index: 500;
}

.home_right_topRight {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  position: absolute;
  background: white;
  width: 150px;
  height: 50px;
  left: 129px;
  top: -51px;
  border: 1px solid #ddd;
  border-bottom: 0px solid #ddd;
  border-left: 0px solid #ddd;
  z-index: 500;
}

.home_right_topLeft span,
.home_right_topRight span {
  color: #666;
  font-size: 20px;
}

.active {
  border-top: 5px solid #e22721;
  top: -50px;
}

.active span {
  color: #e22721;
  font-size: 20px;
}

.box_wai {
  width: 100%;
  padding: 30px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.box {
  cursor: pointer;
  width: 49%;
  text-align: center;
}

.box img {
  width: 86px;
}

.policy_top {
  width: 92%;
  height: 60px;
  line-height: 60px;
  margin: 0 auto;
  font-weight: bold;
}

.policy_top_h1 {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: #e22721;
}

.policy_top_input {
  position: relative;
  width: 92%;
  margin: 0 auto;
  height: 80px;
  line-height: 80px;
}

.policy_top_input label:nth-child(n + 2) {
  margin-left: 30px;
}

.policy_table {
  width: 92%;
  margin: 10px auto;
}

span.ant-tag {
  cursor: pointer;
}

/*遮罩层*/

.modall {
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  background-color: white;
  width: 900px;
  padding-bottom: 20px;
  margin: 50px auto;
  border: 1px solid #ccc;
}

.maska {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 7934;
  width: 100%;
  height: 100%;
}

.modall_top {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}

.modall_top2 {
  width: 92%;
  margin: 10px auto;
  display: flex;
}

.modall_top2 div {
  text-align: center;
  flex: 1;
}

.modall_middle {
  width: 92%;
  margin: 0 auto;
  height: 360px;
  border: 1px solid #ddd;
  overflow-y: auto;
}

.modall_bottom {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}

.modall_button {
  width: 100px;
  height: 40px !important;
  background-color: #3598dc;
  border-color: #3598dc;
}

.modall_button:nth-child(2) {
  margin-left: 50px;
}

li.ant-pagination-item-active {
  border-color: #ff4242;
}

li.ant-pagination-item-active a {
  color: #ff4242;
}

.buttonWaring {
  position: absolute;
  right: 45px;
  top: -50px;
  background: white;
  color: red;
  border: 0px solid #eeeeee;
  width: 60px;
  height: 40px;
  font-size: 20px;
  /*text-decoration:underline;*/
  border-bottom: 1px solid red;
  cursor: pointer;
}

.Section0 span {
  display: inline !important;
}
.onForm_pay svg {
  width: auto !important;
  height: auto !important;
  position: relative !important;
}
